let  BASE_URL = "http://sampark-web-937815106.ap-south-1.elb.amazonaws.com:8081";
// let BASE_URL = "http://3.6.188.10:8181";

export const SRNO_VALIDATE = BASE_URL + "/webassessment/validateSRNumber"
export const SAVE_ASSESSMENT = BASE_URL + "/webassessment/saveAssessmentResults"
export const GET_ASSESSMENT = BASE_URL + "/webassessment/getAssessmentClass"
export const REGISTER_STUDENT = BASE_URL + "/webassessment/registerStudent"